/**
 * Created by Sale on 10/28/2024
 */
import {Role} from "@/utils/utils";
import dataProcessingPage from "@/modules/data-processing-tmc-module/views/data-processing-tmc-page/data-processing-tmc-page.vue";
import videoCalibrationPage
    from "@/modules/data-processing-tmc-module/views/video-calibration-speed-page/video-calibration-speed-page.vue";
import autoValidationReviewPage
    from "@/modules/data-processing-tmc-module/views/auto-validation-tmc-review-page/auto-validation-tmc-review-page.vue";
import importDataValidationPage
    from "@/modules/data-processing-tmc-module/views/import-data-validation-tmc-page/import-data-validation-tmc-page.vue";

const Module = () => import("./Module.vue");

const moduleRoute = {
    path: "/data-processing-nearmiss",
    component: Module,
    children: [
        {
            path: '/',
            name: 'data-processing-nearmiss',
            meta: {
                product: 'Realite Admin',
                title: 'Data Processing Nearmiss',
                isSubCategory: false,
                roles: [Role.ADMIN, Role.TRAFFIC_ENG],
                permission:'data-processing:get-report',
                topBarTitle: '',
                menuPriority: 7,
                hasMenu: true,
                hasInternalTransition: false,
                menuGroup: 'Data',
                menuGroupPriority: 3
            },
            component: dataProcessingPage
        },
        {
            path: '/video-calibration-nearmiss/:projectId?/:dataDeviceId?',
            name: 'video-calibration-nearmiss',
            meta: {
                product: 'Realite Admin',
                title: 'Video Calibration Nearmiss',
                isSubCategory: true,
                roles: [Role.ADMIN, Role.TRAFFIC_ENG],
                permission:'data-processing:list-video-calibrations',
                topBarTitle: 'Video Calibration Nearmiss',
                menuPriority: 7,
                hasMenu: true,
                hasInternalTransition: false
            },
            props: true,
            component: videoCalibrationPage
        },
        {
            path: '/auto-validation-review-nearmiss/:projectId?/:dataDeviceId?/:dataType?',
            name: 'auto-validation-review-nearmiss',
            meta: {
                product: 'Realite Admin',
                title: 'Auto Validation Review Nearmiss',
                isSubCategory: true,
                roles: [Role.ADMIN, Role.TRAFFIC_ENG],
                permission:'data-processing:get-report',
                topBarTitle: 'Auto Validation Review Nearmiss',
                menuPriority: 7,
                hasMenu: true,
                hasInternalTransition: false
            },
            props: true,
            component: autoValidationReviewPage
        },
        {
            path: '/import-data-validation-nearmiss/:projectId?/:dataDeviceId?',
            name: 'import-data-validation-nearmiss',
            meta: {
                product: 'Realite Admin',
                title: 'Import Data Validation Nearmiss',
                isSubCategory: true,
                roles: [Role.ADMIN, Role.TRAFFIC_ENG],
                permission:'data-processing:get-report',
                topBarTitle: 'Import Data Validation Nearmiss',
                menuPriority: 7,
                hasMenu: true,
                hasInternalTransition: false
            },
            props: true,
            component: importDataValidationPage
        },
    ]
};

export default router => {
    router.addRoutes([moduleRoute]);
};
